import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth/auth.guard';
import { TenantResolver } from './core/resolvers/tenant/tenant.resolver';
import { NotFoundComponent } from './core/components/not-found/not-found.component';

/**
 * Padrão multitenant real confirmado em
 * https://dev-cliente.affix.com.br/{tenantSlug}/ (ex.: `affixbeneficios`,
 * 24/08/2026): o PRIMEIRO SEGMENTO da URL é o slug do tenant — diferente do
 * v1 (subdomínio, ver ARQUITETURA.md) e do portal-multiempresas-frontend
 * (também subdomínio).
 *
 * `:tenant` é resolvido pelo TenantResolver, que carrega os parâmetros da
 * Administradora antes de liberar a navegação para as rotas filhas. A rota
 * '' dentro de `:tenant` é o módulo de auth (a tela real de
 * `/{tenant}/` é a de login, sem shell de layout — ver app.component.html).
 *
 * `cliente` é a base do app pós-login — CONFIRMADO ao vivo em 27/08/2026
 * (tenant conectaplan): a rota real é `/{tenant}/cliente` (Home) e
 * `/{tenant}/cliente/{slug}` pra cada subtela (FLAT, não aninhada sob a
 * seção — ex.: cards de Financeiro levam a `/cliente/{slug}`, não
 * `/cliente/financeiro/{slug}`). Renomeado de `inicio` (palpite anterior,
 * nunca confirmado) — ver HomeModule/home-routing.module.ts pra estrutura
 * completa dos filhos.
 */
const routes: Routes = [
  {
    path: ':tenant',
    resolve: { tenant: TenantResolver },
    children: [
      {
        path: '',
        loadChildren: () => import('./modules/auth/auth.module').then((m) => m.AuthModule),
      },
      {
        path: 'cliente',
        canActivate: [AuthGuard],
        loadChildren: () => import('./modules/home/home.module').then((m) => m.HomeModule),
      },
      { path: '**', component: NotFoundComponent },
    ],
  },
  { path: '**', component: NotFoundComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      // Necessário para o AuthGuard/TenantResolver conseguirem ler o slug do
      // tenant (`route.paramMap.get('tenant')`) mesmo a partir de rotas
      // filhas aninhadas (ex.: /{tenant}/inicio).
      paramsInheritanceStrategy: 'always',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
